import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, NavigationExtras, Navigation } from '@angular/router';

@Component({
	selector: 'app-season-bag-new-modal-status-change',
	templateUrl: './season-bag-new-modal-status-change.component.html',
	styleUrls: ['./season-bag-new-modal-status-change.component.scss'],
})
export class SeasonBagNewModalStatusChangeComponent {
	constructor(
		private readonly router: Router,
		private readonly dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public element: any,
	) {}

	changeOfferTerms(change) {
		this.element.action_term = change;
		this.dialogRef.close(this.element);
	}
}
